import React, { Children } from 'react';
import { motion } from 'framer-motion';
// Concepto 2: Señal con reveal secuencial
// Las tres frases aparecen en cadena con 1.2s de pausa entre ellas.
// El efecto es de conversación, no de animación.
const phraseVariants = {
  hidden: {
    opacity: 0,
    y: 12
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.9,
      ease: 'easeOut'
    }
  }
};
const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 1.2
    }
  }
};
export function SignalSection() {
  return <section className="bg-gradient-section px-5 md:px-8 py-12 md:py-28" style={{
    paddingBottom: "0px"
  }} data-id="element-350" data-mp="3dsbfgjmd7qkl">
      <div className="max-w-2xl mx-auto" data-id="element-351" data-mp="2zwprmfrvbctr">
        {/* Eyebrow — pequeño, sutil */}
        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="uppercase tracking-[0.28em] text-[#C8A870] font-semibold mb-5 md:mb-12 text-[11px] text-center" style={{
        fontFamily: 'sans-serif'
      }} data-id="element-352" data-mp="34w2hl9e1d00k">
          Lo que está pasando
        </motion.p>

        {/* Bloque de frases secuenciales */}
        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        amount: 0.4
      }} className="text-left md:text-center" data-id="element-353" data-mp="1996x0lmc7yma">
          {/* Frase 1 — la más grande: elemento dominante del primer viewport */}
          <motion.h2 variants={phraseVariants} className="font-display font-bold text-[#F0E8D8] leading-[1.02] tracking-tight" style={{
          fontSize: 'clamp(42px, 12vw, 64px)',
          marginBottom: '0.16em'
        }} data-id="element-354" data-mp="1wz17iwj6pb3d">
            Tu cuerpo
            <br data-id="element-355" data-mp="21266wq7ywwns" />
            no falló.
          </motion.h2>

          {/* Espacio visual entre frases — compacto en mobile */}
          <div style={{
          height: 'clamp(0.5rem, 3vw, 1.6em)'
        }} data-id="element-356" data-mp="bmgb9x87jlwy" />

          {/* Frase 2 — gold italic */}
          <motion.p variants={phraseVariants} className="font-display italic text-gradient-gold leading-[1.1]" style={{
          fontSize: 'clamp(26px, 6vw, 48px)',
          marginBottom: '0.16em'
        }} data-id="element-357" data-mp="6pgc869rzjfc">
            Cambió la señal.
          </motion.p>

          {/* Espacio visual */}
          <div style={{
          height: 'clamp(0.5rem, 3vw, 1.6em)'
        }} data-id="element-358" data-mp="2gniwt7qvd5df" />

          {/* Frase 3 — pequeña, apagada */}
          <motion.p variants={phraseVariants} className="font-display text-[#F0E8D8]/55" style={{
          fontSize: 'clamp(16px, 3.5vw, 26px)'
        }} data-id="element-359" data-mp="2kric5n0exy57">
            Y nadie te enseñó a leerla.
          </motion.p>
        </motion.div>

        {/* Párrafo explicativo — aparece después, más cerca del bloque anterior en mobile */}
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7,
        delay: 0.3
      }} className="mt-6 md:mt-14 max-w-lg mx-auto text-center" data-id="element-360" data-mp="34e6jiz5g1zk1">
          {/* Idea 1 — el problema */}
          <p className="font-body text-[#F0E8D8]/60" style={{
          fontSize: 'clamp(14px, 2.5vw, 18px)',
          lineHeight: 1.6
        }} data-id="element-361" data-mp="11r9dz84rq2qv">
            Seguís haciendo muchas de las cosas que antes te funcionaban.
            Pero algo dejó de encajar.
          </p>

          {/* Idea 2 — puente hacia la solución: más peso que la idea 1 */}
          
        </motion.div>

        <div className="divider-fine w-16 mx-auto mt-8 md:mt-14" data-id="element-362" data-mp="nu2xjk7iog4t" />
      </div>
    </section>;
}